import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import classNames from 'classnames';
import React, { useCallback, useContext } from 'react';
import { getCompProps } from '../_utils';
import devWarning from '../_utils/devwarning';
import { tuple } from '../_utils/type';
import ConfigContext from '../config-provider/ConfigContext';
import Icon from '../icon';
import { onClipboardCopy, onClipboardCut } from './util';
export var ClipboardActions = tuple('copy', 'cut');
export var ClipboardSizes = tuple('large', 'middle', 'small');
var InternalClipboard = function InternalClipboard(props, ref) {
  var _context, _classNames;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  // 剪贴板参数，合并了系统默认参数、用户定义组件统一参数及组件传参
  var clipboardProps = getCompProps('Clipboard', userDefaultProps, props);
  var className = clipboardProps.className,
    customPrefixcls = clipboardProps.prefixCls,
    action = clipboardProps.action,
    content = clipboardProps.content,
    children = clipboardProps.children,
    disabled = clipboardProps.disabled,
    icon = clipboardProps.icon,
    size = clipboardProps.size,
    target = clipboardProps.target,
    onError = clipboardProps.onError,
    onSuccess = clipboardProps.onSuccess,
    others = __rest(clipboardProps, ["className", "prefixCls", "action", "content", "children", "disabled", "icon", "size", "target", "onError", "onSuccess"]);
  devWarning(ClipboardActions.indexOf(action) === -1, 'clipboard', "cannot found clipboard action '".concat(action, "'"));
  devWarning(ClipboardSizes.indexOf(size) === -1, 'clipboard', "cannot found clipboard size '".concat(size, "'"));
  // 剪贴板样式前缀
  var clipboardPrefixCls = getPrefixCls(prefixCls, 'clipboard', customPrefixcls);
  var clipboardClass = classNames(clipboardPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(clipboardPrefixCls, "-size-")).call(_context, size), size), _defineProperty(_classNames, "".concat(clipboardPrefixCls, "-icon-only"), !children && children !== 0 && icon !== null), _classNames));
  // ref
  var clipboardRef = ref || /*#__PURE__*/React.createRef();
  // 如果没有传 icon，则使用默认图标
  // 如果 icon 传 null，则不使用图标
  var iconNode = icon || (icon === undefined ? /*#__PURE__*/React.createElement(Icon, {
    type: "copy-code"
  }) : null);
  // 如果传的 children 为 string，则将 children 包装成块标签
  var childrenNode = typeof children === 'string' ? /*#__PURE__*/React.createElement("span", null, children) : children;
  /**
   * 剪贴板 click 事件处理
   */
  var handleClick = useCallback(function () {
    if (disabled) {
      // 禁用状态不触发点击事件
      return;
    }
    var selectedText;
    try {
      if (content) {
        // 如果传了 content，则直接复制 content
        selectedText = onClipboardCopy(content);
      } else {
        var targetElement = typeof target === 'string' ? document.querySelector(target) : target();
        if (!targetElement) {
          // 没有获取到元素，抛出异常
          throw new Error("target element '".concat(target, "' does not exist"));
        } else {
          if (action === 'copy' && targetElement.hasAttribute('disabled')) {
            // 复制被置为 disabled 的元素，抛出异常
            throw new Error("invalid \"target\" attribute of element '".concat(targetElement, "'. Please use \"readonly\" instead of \"disabled\" attribute"));
          }
          if (action === 'cut' && (targetElement.hasAttribute('readonly') || targetElement.hasAttribute('disabled'))) {
            // 剪切被置为 readonly 或 disabled 的元素，抛出异常
            throw new Error("invalid \"target\" attribute of element '".concat(targetElement, "'. You can't cut text from elements with \"readonly\" or \"disabled\" attributes"));
          }
        }
        // 对 targetElement 的值进行复制或剪切
        selectedText = action === 'copy' ? onClipboardCopy(targetElement) : onClipboardCut(targetElement);
      }
    } catch (error) {
      // 触发失败的回调
      onError === null || onError === void 0 ? void 0 : onError(error);
      // 退出处理器
      return;
    }
    // 触发成功的回调
    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(selectedText);
  }, [action, content, disabled, onError, onSuccess, target]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clipboardClass,
    disabled: disabled,
    onClick: handleClick,
    ref: clipboardRef
  }, others), iconNode, childrenNode);
};
var Clipboard = /*#__PURE__*/React.forwardRef(InternalClipboard);
Clipboard.displayName = 'Clipboard';
export default Clipboard;